import { useState } from "react";
import { Eye, EyeOff, Loader2, Plug } from "lucide-react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/apiClient";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function OpenAIKeyInput({ value, onChange, onClear, masked = "", unavailable = false, prefix = "openai-key", disabled = false, provider = "openai" }) {
  const [visible, setVisible] = useState(false);
  const [testing, setTesting] = useState(false);
  const test = async () => {
    if (!value.trim()) return;
    setTesting(true);
    try {
      const { data } = await api.post(`/settings/test-${provider}-key`, { api_key: value.trim() });
      data.ok ? toast.success(data.message) : toast.error(data.message);
    } catch (error) { toast.error(apiError(error)); }
    finally { setTesting(false); }
  };
  return (
    <div className="space-y-2">
      {unavailable && <p className="text-xs text-amber-600">Key tersimpan tidak dapat dibaca dengan ENCRYPTION_KEY aktif. Isi ulang atau hapus key.</p>}
      <div className="relative">
        <Input type={visible ? "text" : "password"} value={value} onChange={(event) => onChange(event.target.value)} disabled={disabled} autoComplete="new-password" data-testid={`${prefix}-input`} className="bg-[#F1F5F9] border-[#E2E8F0] pr-10 font-mono-code text-xs" placeholder={masked ? `${masked} (tersimpan)` : provider === "gemini" ? "AIza..." : "sk-proj-..."} />
        <button type="button" onClick={() => setVisible((shown) => !shown)} disabled={disabled} aria-label={visible ? "Sembunyikan API key" : "Tampilkan API key"} data-testid={`${prefix}-toggle`} className="absolute right-2.5 top-1/2 -translate-y-1/2 text-slate-600">{visible ? <EyeOff size={15} /> : <Eye size={15} />}</button>
      </div>
      <div className="flex flex-wrap gap-2">
        <Button type="button" onClick={test} disabled={disabled || testing || !value.trim()} variant="outline" data-testid={`${prefix}-test-button`} className="border-purple-500/40 bg-purple-500/10 text-purple-700 text-xs">{testing ? <Loader2 size={14} className="mr-1 animate-spin" /> : <Plug size={14} className="mr-1" />}Test API Key</Button>
        {(masked || unavailable || value) && <Button type="button" onClick={onClear} disabled={disabled} variant="outline" data-testid={`${prefix}-clear-button`} className="border-red-500/40 text-red-700 text-xs">Hapus Key</Button>}
      </div>
    </div>
  );
}
